import { Component } from '@angular/core';
import { CompaniasProvider } from '../../providers/companias/companias';
import { AuthService } from '../../providers/auth-service';
import { NavController } from 'ionic-angular';
import { Storage } from '@ionic/storage'

@Component({
  selector: 'informe-cambios-maestro',
  templateUrl: 'informe-cambios-maestro.html',
  providers: [ AuthService ]
})
export class InformeCambiosMaestroComponent {

  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  companiasId
  listaTablas=[]
  listaTablasId
  lista = []
  buscar
  jsonData = []
  jsonDataComparar = []
  nombre= "Valor inicial"
  nombreActualizado="Valor actualizado"
  diferencia = []
  usuariosId
  constructor(public servicioCompania:CompaniasProvider,   public auth: AuthService,
    public navCtrl: NavController,    private storage: Storage,
  ) {
    this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId','usuariosId'])
    .then((val)=>{

      if(val){
        this.nombreCompaniaHeader = val['nombreCompania']
        this.nombreCargoHeader = val['nombreCargo']
        this.companiasId = val['companiasId']
        this.usuariosId = val['usuariosId']
      }
    })
    this.buscarDatos()
  }
  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }
  buscarDatos(){
    this.storage.get('companiasId').then((val) => {
    this.companiasId = val
    this.servicioCompania.buscarNombreTablas()
    .subscribe(
      res => {
        this.listaTablas = JSON.parse(res['_body']).data[0]
      },
      err => {
      }
    )
  })

  }

  buscarporCompania(event:any) {
    let nombreTabla = event >= 0 && event < this.listaTablas.length ? this.listaTablas[event].nombre : '';
    this.storage.get('companiasId').then((val) => {
    this.jsonData = []
    this.jsonDataComparar = []
    this.diferencia = []
    this.servicioCompania.buscarLogPorTabla(val,nombreTabla)
      .subscribe((data)=>{
        this.lista =  JSON.parse(data['_body']).data[0]

      },(error)=>{
        console.log(error)
      })
    }
  )}

  xmlConvert(data: any) {
    const formattedXml: string = data;
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(formattedXml, "text/xml");

    //Llama a la función y asigna el resultado a 'jsonData'
    let values: any = this.xmlToJson(xmlDoc.documentElement);
    let response = values && values.children && values.children.length > 0 ? values.children : [];
    return response;
  }

  // Función para convertir XML a JSON
  xmlToJson(xml: Element | HTMLElement): any {
    const obj: any = {
      nodeName: xml.nodeName,
      attributes: {},
      children: [],
      value: ""
    };

    for (let i = 0; i < xml.attributes.length; i++) {
      const attribute = xml.attributes.item(i);
      if (attribute) {
        obj.attributes[attribute.nodeName] = attribute.nodeValue;
      }
    }

    if (xml.firstChild instanceof Text) {
      obj.value = xml.firstChild.nodeValue;
    }

    for (let i = 0; i < xml.children.length; i++) {
      const child = xml.children.item(i);
      if (child instanceof Element) {
        obj.children.push(this.xmlToJson(child));
      }
    }

    return obj; // Retornar el objeto JSON convertido
  }

  visualizarArchivo(item:any) {
     // XML string que deseas representar
     let datoAntes = item.datoAntes
     let dataDespues = item.datoDespues
     if(datoAntes !== undefined) {
      this.jsonData = this.xmlConvert(datoAntes)
     }
     if(datoAntes !== undefined) {
      this.jsonDataComparar = this.xmlConvert(dataDespues)
     }
     this.diferencias(this.jsonData,this.jsonDataComparar)

  }

  diferencias(uno: any,dos:any) {
    let differences = [];
    for (let i = 0; i < uno.length; i++) {
        for (let prop in uno[i]) {
            if (uno[i][prop] !== dos[i][prop]) {
                differences.push({
                    nodeName: uno[i].nodeName,
                    prop: prop,
                    valueUno: uno[i][prop],
                    valueDos: dos[i][prop]
                });
            }
        }
    }
    this.diferencia = differences;
  }

  armarXML(value) {
    const xmlString: string = value;

    // Crear un nuevo DOMParser
    const parser: DOMParser = new DOMParser();

    // Analizar la cadena XML en un documento XML
    const xmlDoc: Document = parser.parseFromString(xmlString, "text/xml");

    // Acceder al contenido del documento XML en formato legible
    const formattedXml: string = new XMLSerializer().serializeToString(xmlDoc);

    // Puedes utilizar 'formattedXml' en tu aplicación TypeScript para mostrar el XML de manera más legible
    return formattedXml
  }
}



// WEBPACK FOOTER //
// ./src/components/informe-cambios-maestro/informe-cambios-maestro.ts